import * as ExcelJS from "exceljs";
import saveAs from "file-saver";
import dayjs from "dayjs";
import { sort } from "ramda";
import { EXCEL_CONFIG, FILE_NAMES } from "../constants/excel";

export const createTravelExpenseExcel = async values => {
    const response = await fetch(FILE_NAMES.REISKOSTEN_TEMPLATE);
    const data = await response.arrayBuffer();
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(data);

    const worksheet = workbook.getWorksheet(EXCEL_CONFIG.WORKSHEET_NAME);

    worksheet.getCell(EXCEL_CONFIG.CELL_MAPPINGS.NAME).value = values.name;
    worksheet.getCell(EXCEL_CONFIG.CELL_MAPPINGS.CITY).value = values.city;
    worksheet.getCell(EXCEL_CONFIG.CELL_MAPPINGS.MONTH).value = dayjs(
        values.month
    )
        .locale("nl")
        .format("MMMM YYYY");

    EXCEL_CONFIG.CELLS_TO_PAINT.forEach(cell => {
        const cellObj = worksheet.getCell(cell);
        cellObj.fill = EXCEL_CONFIG.STYLING.PRIMARY_FILL;
        cellObj.font = EXCEL_CONFIG.STYLING.WHITE_FONT;
    });

    const sortedDates = sort((a, b) => a - b, values.dates);
    sortedDates.forEach((date, index) => {
        const row = EXCEL_CONFIG.CELL_MAPPINGS.START_ROW + index;
        worksheet.getCell(`B${row}`).value = dayjs(date)
            .locale("nl")
            .format("DD-MM-YYYY");
        worksheet.getCell(`C${row}`).value = `Retour ${values.city} - Zwolle`;
        worksheet.getCell(`D${row}`).value = `Retour Zwolle - ${values.city}`;
        worksheet.getCell(`E${row}`).value = "woon - werk";
        worksheet.getCell(`F${row}`).value = parseInt(values.totalKm);
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer]);
    const fileName = `reiskosten-${values.name}-${dayjs(values.month).locale("nl").format("DD-MM-YYYY")}.xlsx`;

    saveAs(blob, fileName);
};

export const createWorkFromHomeExcel = async values => {
    const response = await fetch(FILE_NAMES.THUISWERK_TEMPLATE);
    const data = await response.arrayBuffer();
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(data);

    const worksheet = workbook.getWorksheet(
        EXCEL_CONFIG.THUISWERK_WORKSHEET_NAME
    );

    worksheet.getCell(EXCEL_CONFIG.CELL_MAPPINGS.NAME).value = values.name;
    worksheet.getCell(EXCEL_CONFIG.CELL_MAPPINGS.CITY).value = values.city;
    worksheet.getCell(EXCEL_CONFIG.CELL_MAPPINGS.MONTH).value = dayjs(
        values.month
    )
        .locale("nl")
        .format("MMMM YYYY");

    const sortedDates = sort((a, b) => a - b, values.dates);
    sortedDates.forEach((date, index) => {
        const row = EXCEL_CONFIG.CELL_MAPPINGS.START_ROW + index;
        worksheet.getCell(`D${row}`).value = dayjs(date)
            .locale("nl")
            .format("DD-MM-YYYY");
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer]);
    const fileName = `thuiswerkdagen-${values.name}-${dayjs(values.month).locale("nl").format("DD-MM-YYYY")}.xlsx`;

    saveAs(blob, fileName);
};
